/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Presets_None_TextInputs */



/**
* | output |
* | --- |
* | "You have not saved any transcript export presets yet." |
*
* @param {Transcript_Export_Presets_None_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_presets_none_text = /** @type {((inputs?: Transcript_Export_Presets_None_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Presets_None_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous n'avez encore enregistre aucun prereglage d'exportation de transcription.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben noch keine Exportvoreinstellungen für Transkripte gespeichert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non hai ancora salvato alcun preset di esportazione della trascrizione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вы еще не сохранили ни одного параметра экспорта стенограммы.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no has guardado ningún ajuste preestablecido de exportación de transcripción.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您尚未保存任何转录导出预设。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トランスクリプトのエクスポートプリセットがまだ保存されていません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपने अभी तक कोई भी ट्रांसक्रिप्ट एक्सपोर्ट प्रीसेट सेव नहीं किया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Você ainda não salvou nenhuma predefinição de exportação de transcrição.")
	return /** @type {LocalizedString} */ ("You have not saved any transcript export presets yet.")
});